'use client'

import { BodyText, PageHeading } from '@/components/ui/typography'
import { Reveal } from '@/components/ui/reveal'

interface BlogHeroProps {
  title: string
  subtitle: string
}

export function BlogHero({ title, subtitle }: BlogHeroProps) {
  return (
    <Reveal className="flex flex-col gap-6 text-center" viewportAmount={0.5}>
      <PageHeading className="text-4xl font-semibold sm:text-5xl">
        {title}
      </PageHeading>
      <BodyText className="text-muted-foreground text-lg sm:text-xl">
        {subtitle}
      </BodyText>
    </Reveal>
  )
}
